import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";

const ProgressiveAvatar = ({ src, alt, className }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative ${className}`} style={{ width: 32, height: 32 }}>
      {/* Fallback image shown while loading */}
      <div 
        className={`absolute inset-0 transition-opacity duration-300 ${loaded ? 'opacity-0' : 'opacity-100'}`}
      >
        <StaticImage
          src="../images/userprofile.png"
          alt="Cargando perfil"
          className="w-full h-full rounded-full object-cover"
        />
      </div>

      {/* Actual image hidden until loaded */}
      {src && (
        <img loading="lazy" decoding="async"
          src={src}
          alt={alt}
          onLoad={() => setLoaded(true)}
          className={`absolute inset-0 w-full h-full rounded-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        />
      )}
    </div>
  );
};

export default ProgressiveAvatar;
